import React from 'react'
import { TransactionPayloadType } from 'storeTypes'
import { PaymentRow } from './PaymentRow'
import { isSupportedTransaction } from 'helpers'
import { useTranslation } from 'react-i18next'
import { useInfiniteScroll } from 'hooks'

type PaymentHistoryProps = {
    transactions: [string, TransactionPayloadType[]][]
}

export const PaymentHistory: React.FC<PaymentHistoryProps> = ({
    transactions
}) => {
    const { t } = useTranslation()

    const ITEMS_PER_LOAD = parseInt(
        process.env.REACT_APP_ITEMS_PER_LOAD || '30',
        10
    )

    const filteredTransactions = transactions
        .map(([dateReceived, transactionList]) => [
            dateReceived,
            transactionList.filter(isSupportedTransaction)
        ])
        .filter(([, transactionList]) => transactionList.length > 0)

    const { renderedItems } = useInfiniteScroll({
        filteredItems: filteredTransactions,
        itemsPerLoad: ITEMS_PER_LOAD,
        createItemCard: (item, index) => (
            <PaymentRow
                key={index}
                transactionList={item[1] as TransactionPayloadType[]}
                dateReceived={item[0] as string}
            />
        ),
        containerClassName: 'payment-history-container'
    })

    return (
        <div>
            {filteredTransactions.length === 0 ? (
                <div className="client-payment--no-payments">
                    <p>{t('village.hasNoPayments')}</p>
                </div>
            ) : (
                <div>{renderedItems}</div>
            )}
        </div>
    )
}
